export default {
    "NotSupportFile": "Este arquivo não é suportado, tente outro.",
    "LoginWithGoogle": "Inicie com Google",
    "SignUpWithGoogle": "Registre-se com o Google",
    "BachFileNoLimit": "Processar arquivos grandes em lote sem limite de tamanho",
    "ConvertVideoTo300Formats": "Um clique para converter vídeo para mais de 300 formatos de áudio",
    "120XDownloadSites": "Baixar Áudio 120X Mais Rápido de Mais de 10.000 Sites Populares",
    "DownloadDesktopToExtract": "Baixar a versão para PC para extrair áudio do YouTube e outros mais de 10.000 sites",
    "DownloadDesktopNoLimit": "Baixar a versão para PC para processar arquivos grandes em lote sem limite de tamanho",
    "BachThousandOfFormats": "Converter arquivos de vídeo e áudio em lote para mais de 1000 formatos com velocidade 120X mais rápida",
    "DownloadVIdeoByThousandsOfSites": "Baixar e salvar vídeos de mais de 10.000 sites, como YouTube, TikTok, Instagram, etc.",
    "RichEditingFeatures": "Recursos avançados de edição de vídeo integrados: combinar, cortar, recortar, adicionar marca d'água etc.",
    "ConvertMusicWithDrm": "Converta o Apple Music para MP3 com o DRM removido (somente na versão Windows)",
    "Try It Free": "Testar Grátis",
    "NotNow": "Agora não",
    "300Formats": "Mais de 300 formatos",
    "Convert300FormatsByDesktop": "Ussr o conversor de áudio (versão PC) para converter vídeos para mais de 300 formatos de áudio",
    "ExtractingAudio": "Extraindo áudio...",
    "120XFasterToConvert": "Converta vídeos para áudio 120X mais rápido no HitPaw Video Converter",
    "FailedToExtract": "Falha ao extrair o áudio, tente obter o áudio do vídeo usando o poderoso HitPaw Video Converter.",
    "SureToStopExtract": "Tem certeza de que deseja parar de extrair áudio?",
    "Cancel": "Cancelar",
    "Stop": "Pare",
    "DownloadAudio": "Baixando áudio...",
    "120XDownloadVideoFromWebsites": "Baixar áudio 120X mais rápido de mais de 10.000 sites no Conversor de Vídeo do HitPaw",
    "SureToStopDownload": "Tem certeza que vai parar de baixar o áudio?",
    "ExtractingAudioInThousandsSites": "Extrair áudio do YouTube e outros 10.000 sites usando o Conversor de Vídeo do HitPaw.",
    "Upload New Video": "Carregar novo vídeo",
    "Download": "Baixando áudio...",
    "Download Successful": "Baixe com sucesso!",
    "Failed to download": "Falhou o download.",
}